import { LanguageKeys } from 'src/common/constants/languages';
import { ITrackMap } from 'src/interfaces/TrackMap';

type TrackMapDisplaySource = Pick<ITrackMap, 'i18n' | 'name'>;

export function getTrackMapDisplayName(
  track: TrackMapDisplaySource,
  lang: LanguageKeys,
): string {
  const translated = track.i18n?.[lang]?.trim();
  if (translated) return translated;
  return track.name;
}
